import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IState } from '../../../store';
import { showGalleryElement } from '../../../store/gallery';
import { Controls, IControlsProps } from './controls';
import { setNewbuildingMvkIsWidgetOpenAction } from '../../../store/newbuilding_mvk';
import {
  isCianLayoutSelector,
  isSingleGalleryCountSelector,
  isVideoSelector,
  layoutPositionIdSelector,
  photoCountSelector,
} from './utils/selectors';

type TStoreProps = Pick<
  IControlsProps,
  | 'isInitialized'
  | 'isSingleGalleryCount'
  | 'isVideo'
  | 'isVideoPlay'
  | 'layoutId'
  | 'photoCount'
  | 'isFloorPlan'
  | 'isCianLayout'
>;

type TDispatchProps = Pick<IControlsProps, 'onElementShow' | 'openMvkWidget'>;

export function mapStateToProps(state: IState): TStoreProps {
  return {
    photoCount: photoCountSelector(state),
    isSingleGalleryCount: isSingleGalleryCountSelector(state),
    isVideo: isVideoSelector(state),
    layoutId: layoutPositionIdSelector(state),
    isCianLayout: isCianLayoutSelector(state),
    isInitialized: state.gallery.isInitialized,
    isVideoPlay: state.gallery.isVideoPlayed,
    isFloorPlan: Boolean(state.newbuildingMvk.MVKData),
  };
}

export function mapDispatchToProps(dispatch: Dispatch<IState>): TDispatchProps {
  return {
    onElementShow: (id: number) => {
      dispatch(showGalleryElement(id));
    },
    openMvkWidget: () => dispatch(setNewbuildingMvkIsWidgetOpenAction(true)),
  };
}

export const GalleryControlsContainer = connect<TStoreProps, TDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(Controls);
